module.exports = __webpack_public_path__ + "ax.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ax.svg
// module id = 432
// module chunks = 0